import React from 'react';
import { Icon, IconProps } from '@frontend/design-system';

export const GoogleIcon: React.FC<React.PropsWithChildren<IconProps>> = (props) => (
  <Icon size={24} {...props} viewBox='0 0 24 24'>
    <path
      fill='#4285F4'
      fillRule='evenodd'
      d='M24 12.273c0-.851-.078-1.67-.223-2.455H12.245v4.642h6.59c-.284 1.5-1.147 2.771-2.444 3.622v3.01h3.958C22.664 19.005 24 15.928 24 12.273z'
      clipRule='evenodd'
    />
    ,
    <path
      fill='#34A853'
      fillRule='evenodd'
      d='M12.245 24c3.306 0 6.078-1.075 8.104-2.907l-3.958-3.011c-1.096.72-2.499 1.145-4.146 1.145-3.19 0-5.889-2.11-6.852-4.947h-4.09v3.109c2.014 3.922 6.155 6.61 10.942 6.61z'
      clipRule='evenodd'
    />
    ,
    <path
      fill='#FBBC05'
      fillRule='evenodd'
      d='M5.393 14.28A7.083 7.083 0 015.01 12c0-.791.14-1.56.384-2.28V6.61h-4.09a11.8 11.8 0 000 10.779l4.09-3.11z'
      clipRule='evenodd'
    />
    ,
    <path
      fill='#EA4335'
      fillRule='evenodd'
      d='M12.245 4.773c1.798 0 3.412.605 4.68 1.794l3.513-3.442C18.318 1.19 15.545 0 12.245 0 7.458 0 3.317 2.69 1.302 6.61l4.091 3.11c.963-2.836 3.663-4.947 6.852-4.947z'
      clipRule='evenodd'
    />
  </Icon>
);
